export default import.meta.ROLLUP_FILE_URL_opvkZoif6OLhfc3gByGCpg